import { Directive, ElementRef, AfterViewInit } from '@angular/core';

/**
 * Directive to automatically focus the first focusable element in a form.
 * Useful for keyboard navigation and accessibility.
 * 
 * Usage: <form [appAutoFocusFirstInput]>...</form>
 */
@Directive({
  selector: 'form[appAutoFocusFirstInput]',
  standalone: true
})
export class AutoFocusFirstInputDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    // Focus the first available input field after view initialization
    setTimeout(() => {
      const form = this.elementRef.nativeElement;
      if (form) {
        // Find the first input, textarea, or select element (excluding hidden elements and disabled elements)
        const firstFocusable = form.querySelector(
          'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), p-select:not([disabled]), ppl-dropdown-select:not([disabled])'
        ) as HTMLElement;
        
        if (firstFocusable) {
          // If it's a ppl-dropdown-select or p-select, find the internal focusable element
          const tagName = firstFocusable.tagName.toLowerCase();
          if (tagName.includes('select') || tagName === 'ppl-dropdown-select') {
            const internalInput = firstFocusable.querySelector('[role="combobox"], .p-select-label') as HTMLElement;
            if (internalInput) {
              internalInput.focus();
            }
          } else {
            firstFocusable.focus();
          }
        }
      }
    }, 150);
  }
}
